import { render, staticRenderFns } from "./CertificationLoadWrapper.vue?vue&type=template&id=7afacbc2"
import script from "./CertificationLoadWrapper.vue?vue&type=script&lang=js"
export * from "./CertificationLoadWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7afacbc2')) {
      api.createRecord('7afacbc2', component.options)
    } else {
      api.reload('7afacbc2', component.options)
    }
    module.hot.accept("./CertificationLoadWrapper.vue?vue&type=template&id=7afacbc2", function () {
      api.rerender('7afacbc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/massiveCertificationLoad/CertificationLoadWrapper.vue"
export default component.exports